import React from 'react';
import './DynamicContentBadge.module.scss';

const DynamicContentBadge = () => (
  <div styleName="badge">
    Dynamic content
  </div>
);

export default DynamicContentBadge;